import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function TestimonialsInitial() {
  return <section className="py-12 px-4 sm:px-6 lg:px-8 max-w-5xl mx-auto" data-id="element-255">
      <div className="grid md:grid-cols-2 gap-6" data-id="element-256">
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-navy-800/50 border border-navy-700 p-6 rounded-2xl backdrop-blur-sm" data-id="element-257">
          <div className="flex gap-1 mb-3" data-id="element-258">
            {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-gold-400 text-gold-400" data-id="element-259" />)}
          </div>
          <p className="text-lg text-blue-50 italic mb-4" data-id="element-260">
            "El primer mes ahorré más de lo que esperaba. Ahora planeo los
            domingos y la semana entera fluye sola."
          </p>
          <p className="text-gold-400 font-medium" data-id="element-261">— Mariela G., Córdoba</p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-navy-800/50 border border-navy-700 p-6 rounded-2xl backdrop-blur-sm" data-id="element-262">
          <div className="flex gap-1 mb-3" data-id="element-263">
            {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-gold-400 text-gold-400" data-id="element-264" />)}
          </div>
          <p className="text-lg text-blue-50 italic mb-4" data-id="element-265">
            "Con lentejas y zapallo hago tantas comidas distintas. Mi familia
            come mejor que antes."
          </p>
          <p className="text-gold-400 font-medium" data-id="element-266">— Laura P., Rosario</p>
        </motion.div>
      </div>
    </section>;
}